export default "__VITE_ASSET__BC4t3Y0E__"